export default __webpack_public_path__ + "10c1f498ba23bd1d697281cd88f7be03.png";